import react from 'react-dom';

const Whychooseus = ()=>{
    return(
        <section className='whychooseus-contanier'>
                <div className='whychooseus-content-left'>
                    <p>Why Choose Us</p>
                    <h1>Delivering Value That Matters</h1> <hr className="whychooseus-horizontal-line"></hr>
                </div>
          <div className='whychooseus-impact-container'>
               <div className="impact-stats">
                    <div className="stat-item whychooseus-stat-item">
                        <span className="icon"><img src="whychooseus-1.svg"></img></span>
                        <h3>Cloud Optimised</h3>
                        <p>Enhance scalability and performance with solutions</p>
                    </div>
                    <div className="stat-item whychooseus-stat-item">
                        <span className="icon"><img src="whychooseus-2.svg"></img></span>
                        <h3>Agile Approach</h3>
                        <p>Ensuring products are delivered faster with quality</p>
                    </div>
                    <div className="stat-item whychooseus-stat-item">
                        <span className="icon"><img src="whychooseus-3.svg"></img></span>
                        <h3>UI & UX Focussed</h3>
                        <p>We understand the importance of look and feel</p>
                    </div>
                    <div className="stat-item whychooseus-stat-item">
                        <span className="icon"><img src="whychooseus-4.svg"></img></span>
                        <h3>Scalable Solutions</h3>
                        <p>Building products that scale with growth and change</p>
                    </div>
                     <div className="stat-item whychooseus-stat-item">
                        <span className="icon"><img src="whychooseus-5.svg"></img></span>
                        <h3>Secure & Reliable</h3>
                        <p>We ensure your data is safe and privacy is guaranteed</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Whychooseus;